<template>
  <div class="app">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-row>
        <v-col v-for="item in 3" :key="item">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="item in 2" :key="item">
          <v-skeleton-loader class="mx-auto" type="image" height="220" />
        </v-col>
      </v-row>
    </v-sheet>
    <v-form ref="form" v-show="!showSkeleton">
      <v-row>
        <v-col cols="4">
          <v-text-field
            dense
            v-model="form.inicio"
            :error-messages="inicioErrors"
            :counter="10"
            type="number"
            label="Início do Range"
            outlined
            @input="$v.form.inicio.$touch()"
            @blur="$v.form.inicio.$touch()"
          />
        </v-col>
        <v-col cols="4">
          <v-text-field
            dense
            v-model="form.quantidade"
            :error-messages="quantidadeErrors"
            :counter="2"
            type="number"
            label="Quantidade"
            outlined
            @input="$v.form.quantidade.$touch()"
            @blur="$v.form.quantidade.$touch()"
          />
        </v-col>
        <v-col cols="4">
          <v-select
            dense
            v-model="form.tronco"
            :error-messages="troncoErrors"
            :items="troncos"
            outlined
            label="Tronco"
            @input="$v.form.tronco.$touch()"
            @blur="$v.form.tronco.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <DraggAndDrop
            dragname="Rotas"
            :valoresDisponiveisComboBox="rotasGerais.rotasGeralDisponiveis"
            @dragUpdate="updateRotasGeral($event)"
            :opcoesSelecionadas="rotasGerais.rotasGeralSelecionadas"
          />
        </v-col>
        <v-col cols="6">
          <DraggAndDrop
            dragname="Rotas de Transferência"
            :valoresDisponiveisComboBox="rotasTransferencias.rotasTransferenciasDisponiveis"
            @dragUpdate="updateRotasTransferencia($event)"
            :opcoesSelecionadas="rotasTransferencias.rotasTransferenciasSelecionadas"
          />
        </v-col>
      </v-row>

      <div v-for="n in 4" :key="`divider_${n}`">
        <v-divider vertical />
      </div>

      <FixedButtons @salvar="salvar" @cancelar="cancelar" :pararLoader="pararLoader" />
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'

import Snackbar from '@/componentes/Snackbar'
import FixedButtons from '@/componentes/FixedButtons'
import { registerVuexModule, formatarRota } from '@/utils/vuexUtils'
import { ordenar } from '@/utils/ordenarArrayByText'

import ramaisStore from '../_store'
import DraggAndDrop from '../_components/DraggAndDrop'
import { validateData, validateComputed } from '../_validates/validatesVirtualMultiplos'
import RamaisHttpService from '../_services/RamaisHttpService'

export default {
  name: 'AbaRamalPjsipMultiplos',
  components: { DraggAndDrop, Snackbar, FixedButtons },
  mixins: [validationMixin],
  data: () => ({
    form: {
      inicio: '',
      quantidade: '',
      tipo: 'VIRTUAL',
      tronco: '',
      rotasTransferencias: [],
      rota: [],
    },

    rotasTransferencias: {
      rotasTransferenciasDisponiveis: [],
      rotasTransferenciasSelecionadas: [],
    },
    rotasGerais: {
      rotasGeralDisponiveis: [],
      rotasGeralSelecionadas: [],
    },
    troncos: [],
    item: -1,
    text: '',
    snackbar: false,
    showSkeleton: true,
    pararLoader: {
      parar: false,
    },
  }),
  validations: {
    ...validateData,
  },
  computed: {
    ...mapGetters('abaRamalVirtualMultiplosModulePABXStore', ['getTroncosDisponveis', 'getRotasDisponiveis']),
    ...validateComputed,
  },
  async created() {
    registerVuexModule(this.$store, 'abaRamalVirtualMultiplosModulePABXStore', ramaisStore)

    await Promise.all([this.listarTroncos(), this.listarRotas()])
    this.getTroncosDisponveis.forEach(tronco => {
      if (tronco.interno) {
        this.troncos.push({ text: tronco.description, value: tronco._id })
      }
    })

    this.rotasTransferencias.rotasTransferenciasDisponiveis = [...this.getRotasDisponiveis]
    this.rotasGerais.rotasGeralDisponiveis = [...this.getRotasDisponiveis]

    this.rotasTransferencias.rotasTransferenciasSelecionadas = this.getRotasDisponiveis.filter(rota => rota.default)
    this.rotasGerais.rotasGeralSelecionadas = this.getRotasDisponiveis.filter(rota => rota.default)

    ordenar(this.rotasTransferencias.rotasTransferenciasDisponiveis)
    ordenar(this.rotasGerais.rotasGeralDisponiveis)
    this.showSkeleton = false
  },

  methods: {
    ...mapActions('abaRamalVirtualMultiplosModulePABXStore', ['listarTroncos', 'listarRotas']),
    updateRotasGeral(event) {
      this.form.rota = formatarRota(event)
    },
    updateRotasTransferencia(event) {
      this.form.rotaTransferencia = formatarRota(event)
    },
    async salvar() {
      this.pararLoader.parar = false

      if (!this.form.rota['1']) {
        this.text = 'Nenhuma rota selecionada.'
        this.snackbar = true
        this.pararLoader.parar = true
        return
      } else if (!this.form.rotaTransferencia['1']) {
        this.text = 'Nenhuma rota de transferência selecionada.'
        this.snackbar = true
        this.pararLoader.parar = true
        return
      }

      this.$v.$touch()
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
        this.pararLoader.parar = true
        return
      }

      try {
        await RamaisHttpService.postRamaisMultiplos(this.form)
        this.$router.push({ name: 'Ramais' })
      } catch (error) {
        let key = Object.keys(error.response.data)
        this.text = error.response.data[key[0]]
        this.snackbar = true
        this.pararLoader.parar = true
      }
    },
    cancelar() {
      this.$router.push({ name: 'Ramais' })
    },
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
